<img [src]="(context.isAbsolute ? '' : '/assets/project-images/') + context.image"
         alt="{{ context.alt }}"
         [style.max-height]="context.maxHeight ? context.maxHeight + 'rem' : null"
         [style.max-width]="context.maxWidth || '100%'"
         [style.width]="context.width || '100%'"
>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image/image.component.html